import React from "react";
import { Box } from "@mui/material";
import GenericFilterSection from "./GenericFilterSection";
import SearchInput from "components/SearchInput";
import ResetButton from "components/ResetButton";
import { PaginationDropdown } from "components/Pagination";
import TagFilter from "app/pages/Problems/ProblemList/TagFilter";

function FilterSection({
  isAdmin,
  isAdminContext,
  tags,
  selectedTags,
  keysWithOperators,
  search,
  rows,
  onTagChange,
  onKeyChange,
  onSearchChange,
  onReset,
  onRowsPerPageChange,
  addRoute,
  navigate,
  editingKey,
  setEditingKey,
  entityConfig,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      { entityConfig ? (
        <GenericFilterSection
          isAdminContext={isAdminContext}
          entityConfig={entityConfig}
          keysWithOperators={keysWithOperators}
          search={search}
          rows={rows}
          onKeyChange={onKeyChange}
          onSearchChange={onSearchChange}
          onReset={onReset}
          onRowsPerPageChange={onRowsPerPageChange}
          addRoute={addRoute}
          navigate={navigate}
          editingKey={editingKey}
          setEditingKey={setEditingKey}
        />
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            margin: 1,
            flexWrap: { xs: "wrap", sm: "nowrap" },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {!isAdminContext && (
              <TagFilter
                tags={tags}
                selectedTags={selectedTags}
                onTagChange={onTagChange}
              />
            )}
            {selectedTags.length > 0 && <ResetButton onReset={onReset} />}
          </Box>
          <SearchInput
            value={search}
            onChange={(value) => onSearchChange(value)}
            label="Search problems"
            type="search"
            sx={{
              m: 1,
              minWidth: 50,
              width: 300,
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
          />
          <PaginationDropdown
            rows={rows}
            onRowsPerPageChange={onRowsPerPageChange}
            isAdmin={isAdmin}
            addRoute={addRoute}
            navigate={navigate}
          />
        </Box>
      )}
    </Box>
  );
}

export default FilterSection;
